import React from 'react';
import PropTypes from 'prop-types';

import Listing from "../containers/Listing";
import Registration from "../containers/Registration";

import ProgressBar from 'react-toolbox/lib/progress_bar/ProgressBar';
import Button from 'react-toolbox/lib/button/Button';

import {FormRow, Picture, Striped, ThemedHeader, TwoColumnRow, Video, VideoContainer} from '../../Styled';

import siv1 from '../../../images/clinics/siv1.jpg';
import siv2 from '../../../images/clinics/siv2.jpg';
import acro1 from '../../../images/clinics/acro1.jpg';
import acro2 from '../../../images/clinics/acro2.jpg';

const Clinics = ({loadWaiting, loadSuccess, isFilled, submit, submitWaiting, submitSuccess, submitFailure}) => {
    return (
        <React.Fragment>
            <Striped>
                <TwoColumnRow>
                    <span>
                        <ThemedHeader>Simulation d'Incident en Vol</ThemedHeader>
                        <p>Flying is unpredictable at times, but we will teach you how to deal with unexpected events and come out from them still rocking that big smile!</p>
                    </span>
                    <VideoContainer>
                      <Video className='mobile-row-2' src="https://www.youtube.com/embed/cRKvSZk6pdQ?start=50&autoplay=1"
                             allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                             allowFullScreen></Video>
                    </VideoContainer>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <TwoColumnRow>
                    <Picture className='mobile-row-2' src={siv2}/>
                    <span className='mobile-row-1'>We strongly believe that all pilots should partake in SIV clinics as they progress in their flying. Paraglide Utah offers SIV clinics throughout the western United States, Mexico and around the world!</span>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <TwoColumnRow>
                    <ThemedHeader>Aerobatics</ThemedHeader>
                    <Picture src={acro1}/>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <TwoColumnRow>
                    <Picture className='mobile-row-2' src={acro2}/>
                    <span className='mobile-row-1'>Very few pilots want to do aerobatics, but if you are one of them you have - you have found the right place! We even had a few pilots make it through the Infinite Tumble program! After you have completed at least one SIV clinic, enjoyed the G's of the nose down spiral and had fun full stalling your wing, we can progress into basic acro maneuvers. At this point your course will be personalized to your skill level and learning speed.</span>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <FormRow>
                    <ThemedHeader>Registration</ThemedHeader>
                    <span style={{minWidth: "100%"}}>
                        {loadWaiting && <ProgressBar type="linear" mode="indeterminate"/>}

                        {loadSuccess && <Listing/>}

                        <Registration/>

                        {!submitWaiting && !submitSuccess && !submitFailure &&
                         <Button icon='payment' label='Pay with Card' raised primary
                                 disabled={!isFilled} onClick={submit}/>}

                        {submitWaiting && <ProgressBar type="circular" mode="indeterminate"/>}

                        {submitSuccess &&
                         <strong style={{color: 'green'}}>
                             Your card has been charged. Thank you!
                         </strong>}

                        {submitFailure &&
                         <strong style={{color: 'red'}}>
                             Something went wrong! Please let us know and try again later.
                         </strong>}
                    </span>
                </FormRow>
            </Striped>
        </React.Fragment>
    )
};

Clinics.propTypes = {
    loadWaiting:   PropTypes.bool.isRequired,
    loadSuccess:   PropTypes.bool.isRequired,
    isFilled:      PropTypes.bool.isRequired,
    submit:        PropTypes.func.isRequired,
    submitWaiting: PropTypes.bool.isRequired,
    submitSuccess: PropTypes.bool.isRequired,
    submitFailure: PropTypes.bool.isRequired
};

export default Clinics;



// WEBPACK FOOTER //
// ./src/app/clinics/components/Clinics.js